import { render, staticRenderFns } from "./BookingFormCustomerTab.vue?vue&type=template&id=344c1947"
import script from "./BookingFormCustomerTab.vue?vue&type=script&lang=js"
export * from "./BookingFormCustomerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports